import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, LogOut, Users, FileSearch } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export const AdminLayout = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const onLogout = () => {
        logout();
        navigate("/admin/login", { replace: true });
    };

    return (
        <div className="min-h-screen flex flex-col bg-background bg-grain">
            <header className="border-b border-border/80 bg-cream/90 backdrop-blur supports-[backdrop-filter]:bg-cream/70 sticky top-0 z-30">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
                    <div className="flex items-center gap-6">
                        <Link to="/" className="font-display text-xl text-moss">
                            Choice Ayurveda
                        </Link>
                        <span className="text-xs uppercase tracking-wider text-terracotta font-accent">
                            Admin
                        </span>
                    </div>
                    <nav className="flex items-center gap-5 text-sm">
                        <NavLink
                            to="/admin"
                            end
                            data-testid="admin-nav-dashboard"
                            className={({ isActive }) =>
                                `inline-flex items-center gap-1.5 font-medium ${
                                    isActive
                                        ? "text-terracotta"
                                        : "text-foreground/75 hover:text-moss"
                                }`
                            }
                        >
                            <Users className="h-4 w-4" /> Intakes
                        </NavLink>
                        <NavLink
                            to="/admin/drafts"
                            data-testid="admin-nav-drafts"
                            className={({ isActive }) =>
                                `inline-flex items-center gap-1.5 font-medium ${
                                    isActive
                                        ? "text-terracotta"
                                        : "text-foreground/75 hover:text-moss"
                                }`
                            }
                        >
                            <FileSearch className="h-4 w-4" /> Drafts & recovery
                        </NavLink>
                        <NavLink
                            to="/"
                            target="_blank"
                            className="text-foreground/75 hover:text-moss"
                        >
                            View site ↗
                        </NavLink>
                        {user && (
                            <div className="flex items-center gap-3 pl-4 border-l border-border/70">
                                <span className="text-xs text-foreground/60">
                                    {user.email}
                                </span>
                                <button
                                    type="button"
                                    onClick={onLogout}
                                    data-testid="admin-logout"
                                    className="inline-flex items-center gap-1 rounded-xl bg-sand px-3 py-1.5 text-xs text-moss hover:bg-sand/80"
                                >
                                    <LogOut className="h-3.5 w-3.5" /> Sign out
                                </button>
                            </div>
                        )}
                    </nav>
                </div>
            </header>
            <main className="flex-1">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
